import React, { useState } from "react";
import { Button } from "react-bootstrap";
const CreateProfileModal = React.lazy(() => import("./CreateProfileModal"));

// const ApplyNowModal = React.lazy(() => import("./ApplyNowModal"));
// import {Trans } from "react-i18next";
function CreateProfileButton() {
    const [showProfileModal, setShowProfileModal] = useState(false);
    const handleClose = () => setShowProfileModal(false);
    const handleShow = () => setShowProfileModal(true);

    return (
        <>
            <Button
                className="btn-primary rounded-pill"
                onClick={() => {
                    // console.log("clicked");
                    setShowProfileModal(true);
                }}
            >
                Create Pofile
            </Button>



            {showProfileModal && (
                <React.Suspense fallback={<div>Loading...</div>}>
                    <CreateProfileModal
                       showProfileModal={showProfileModal}
                       profileModalShow={handleShow}
                       handleClose={handleClose}
                       target={"CreateProfile"}
                    />
                </React.Suspense>
            )}
        </>
    );
}
export default CreateProfileButton;



